<template>
  <v-container fluid>
    <h1>Aguarde enquanto verificamos seu email</h1>
    <v-dialog v-model="dialogPassoword">
      <v-form>
        <v-chip v-if="user" color="primary" dark close>
          <v-avatar>
            <img v-if="user.image" :src="user.image" alt="trevor">
            <v-icon v-else>account_circle</v-icon>
          </v-avatar>
          {{ user.email }}
        </v-chip>
        <v-flex>
          <v-text-field
            v-model="password"
            :rules="passwordRules"
            label="Password"
            type="password"
            required
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-text-field
            v-model="passwordRepeat"
            :rules="[comparePassowords]"
            label="Repita o Password"
            type="password"
            required
          ></v-text-field>
        </v-flex>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  props: ['mode', 'oobCode', 'lang', 'continueUrl'],
  data () {
    return {
      user: null,
      password: '',
      passwordRepeat: '',
      passwordRules: [v => !!v || 'Insira sua senha!'],
      dialogPassoword: false
    }
  },
  computed: {
    comparePassowords () {
      return this.password !== this.passwordRepeat
        ? 'Senhas não são idênticas!'
        : true
    }
  },
  mounted () {
    var auth = firebase.auth()
    switch (this.mode) {
      case 'resetPassword':
        // Display reset password handler and UI.
        this.handleResetPassword(
          auth,
          this.oobCode,
          this.continueUrl,
          this.lang
        )
        break
      case 'recoverEmail':
        // Display email recovery handler and UI.
        this.handleRecoverEmail(auth, this.oobCode, this.lang)
        break
      case 'verifyEmail':
        // Display email verification handler and UI.
        this.handleVerifyEmail(auth, this.oobCode, this.continueUrl, this.lang)
        break
      default:
        alert('Função inexistente!')
    }
  },
  methods: {
    handleResetPassword (auth, actionCode, continueUrl, lang) {
      auth
        .verifyPasswordResetCode(actionCode)
        .then(email => {
          this.user = {
            email: email
          }

          this.dialogPassoword = true
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleRecoverEmail (auth, actionCode, lang) {
      auth
        .checkActionCode(actionCode)
        .then(info => {
          this.user = {
            email: info['data']['email']
          }

          return auth.applyActionCode(actionCode)
        })
        .then(() => {
          if (confirm('Tem certeza que deseja recuperar seu email?')) {
            auth
              .sendPasswordResetEmail(this.user.email)
              .then(() => {
                alert('Concluído! Consulte seu email para continuar.')
              })
              .catch(error => {
                console.log(error)
              })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleVerifyEmail (auth, actionCode, continueUrl, lang) {
      auth
        .applyActionCode(actionCode)
        .then(resp => {
          this.$router.push('/login')
        })
        .catch(error => {
          console.log(error)
        })
    },
    resetPassword (auth, actionCode, newPassword) {
      auth
        .confirmPasswordReset(actionCode, newPassword)
        .then(resp => {
          auth.signInWithEmailAndPassword(this.user.email, newPassword)
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
